import { KeyboardBackspace } from "@mui/icons-material";
import { Box, Button, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { MainContainer } from "../content/content.element";

function ScheduleDetailPage(props) {
  const navigate = useNavigate();
  return (
    <MainContainer active={props.toggle}>
      <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: 'calc(100vh - 80px)',
      }}>
        <Box sx={{
            overflowY:"scroll",
            "&::-webkit-scrollbar":{
                display: "none",
            }
        }}>
          <Box
            sx={{
              borderBottom: "1px solid rgba(236, 236, 236, 1)",
              mb: "20px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                fontWeight: "700",
                fontSize: "24px",
                pt: "10px",
                pb: "10px",
                width: "fit-content",
                cursor: "pointer",
              }}
              onClick={() => navigate(-1)}
            >
              <KeyboardBackspace />
              Schedule Details
            </Box>
          </Box>
          <Box>
            <Box>
              <Box
                sx={{
                  display: "flex",
                  gap: "10px",
                  justifyContent: "space-between",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "20px",
                  }}
                >
                  <Box
                    sx={{ display: "flex", alignItems: "center", gap: "10px" }}
                  >
                    <Typography
                      sx={{
                        color: "rgba(0, 0, 0, 1)",
                        fotnSize: "14px",
                        lineHeight: "21px",
                      }}
                    >
                      Ticket Owner:{" "}
                    </Typography>
                    <Typography
                      sx={{
                        color: "rgba(131, 131, 131, 1)",
                        fontSize: "14px",
                        lineHeight: "21px",
                      }}
                    >
                      Shabeer Muhammed
                    </Typography>
                  </Box>
                  <Box
                    sx={{ display: "flex", alignItems: "center", gap: "10px" }}
                  >
                    <Typography
                      sx={{
                        color: "rgba(0, 0, 0, 1)",
                        fotnSize: "14px",
                        lineHeight: "21px",
                      }}
                    >
                      Create Date:{" "}
                    </Typography>
                    <Typography
                      sx={{
                        color: "rgba(131, 131, 131, 1)",
                        fontSize: "14px",
                        lineHeight: "21px",
                      }}
                    >
                      15 / 02 / 2023
                    </Typography>
                  </Box>
                  <Box
                    sx={{ display: "flex", alignItems: "center", gap: "10px" }}
                  >
                    <Typography
                      sx={{
                        color: "rgba(0, 0, 0, 1)",
                        fotnSize: "14px",
                        lineHeight: "21px",
                      }}
                    >
                      Scheduled on:{" "}
                    </Typography>
                    <Typography
                      sx={{
                        color: "rgba(131, 131, 131, 1)",
                        fontSize: "14px",
                        lineHeight: "21px",
                      }}
                    >
                      15 / 02 / 2023
                    </Typography>
                  </Box>
                  <Box
                    sx={{ display: "flex", alignItems: "center", gap: "10px" }}
                  >
                    <Typography
                      sx={{
                        color: "rgba(0, 0, 0, 1)",
                        fotnSize: "14px",
                        lineHeight: "21px",
                      }}
                    >
                      Scheduled Time:{" "}
                    </Typography>
                    <Typography
                      sx={{
                        color: "rgba(131, 131, 131, 1)",
                        fontSize: "14px",
                        lineHeight: "21px",
                      }}
                    >
                      09:00 AM to 10:00 AM
                    </Typography>
                  </Box>
                </Box>
                <Button
                  sx={{
                    backgroundColor: "rgba(20, 30, 60, 1)",
                    color: "#fff",
                    borderRadius: "30px",
                    display: "flex",
                    height: "fit-content",
                    gap: "10px",
                    px: "10px",
                    "&:hover": {
                      backgroundColor: "rgba(20, 30, 60, 1)",
                    },
                  }}
                >
                  Pending
                  <svg
                    width="10"
                    height="11"
                    viewBox="0 0 10 11"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2.49063 -0.00564039C2.36073 -0.00176903 2.23744 0.0525379 2.14688 0.145746L0.146882 2.1467C0.100322 2.19315 0.0633823 2.2483 0.038178 2.30904C0.0129736 2.36979 0 2.43492 0 2.50068C0 2.56645 0.0129736 2.63158 0.038178 2.69232C0.0633823 2.75307 0.100322 2.80822 0.146882 2.85467L2.14688 4.85568C2.19309 4.90354 2.24838 4.94169 2.30951 4.96791C2.37065 4.99413 2.43641 5.0079 2.50293 5.00839C2.56945 5.00888 2.6354 4.99611 2.69691 4.97079C2.75843 4.94548 2.81428 4.9081 2.86119 4.86093C2.9081 4.81376 2.94512 4.75776 2.9701 4.6961C2.99507 4.63445 3.00749 4.56839 3.00663 4.50187C3.00577 4.43535 2.99165 4.36966 2.96509 4.30867C2.93853 4.24768 2.90007 4.19261 2.85196 4.14667L1.70645 2.99925H9.49942C9.63216 2.99925 9.75946 2.94651 9.85333 2.85265C9.94719 2.75879 9.99992 2.63146 9.99992 2.49872C9.99992 2.36598 9.94719 2.23871 9.85333 2.14485C9.75946 2.05099 9.63216 1.99825 9.49942 1.99825H1.71134L2.85196 0.854696C2.92477 0.784701 2.97469 0.694262 2.99513 0.595349C3.01556 0.496437 3.00557 0.393658 2.96646 0.300535C2.92735 0.207412 2.86096 0.128315 2.77602 0.0736573C2.69109 0.019 2.59159 -0.00862732 2.49063 -0.00564039ZM7.49551 4.9953C7.39662 4.9961 7.30018 5.0262 7.2184 5.08181C7.13661 5.13742 7.07316 5.21603 7.03605 5.30771C6.99894 5.39938 6.98985 5.50003 7.00993 5.59687C7.03 5.69371 7.07835 5.78241 7.14884 5.85177L8.2963 7.00018H0.501372C0.37066 7.00304 0.246266 7.05701 0.154835 7.15047C0.0634033 7.24392 0.0122044 7.36944 0.0122044 7.50018C0.0122044 7.63093 0.0634033 7.7565 0.154835 7.84996C0.246266 7.94342 0.37066 7.99733 0.501372 8.00019H8.29337L7.14884 9.14767C7.0965 9.1925 7.05398 9.24763 7.02397 9.30967C6.99396 9.37171 6.9771 9.43931 6.97444 9.50817C6.97178 9.57704 6.98338 9.64568 7.00852 9.70985C7.03366 9.77402 7.0718 9.83234 7.12053 9.88107C7.16926 9.9298 7.22754 9.96793 7.2917 9.99307C7.35587 10.0182 7.42454 10.0298 7.49341 10.0272C7.56227 10.0245 7.62984 10.0076 7.69188 9.97762C7.75392 9.9476 7.80908 9.9051 7.85391 9.85276L9.85391 7.85273C9.94705 7.75904 9.99933 7.63229 9.99933 7.50018C9.99933 7.36807 9.94705 7.24133 9.85391 7.14764L7.85391 5.14669C7.80732 5.09879 7.75159 5.06069 7.69004 5.03469C7.62848 5.00869 7.56234 4.99531 7.49551 4.9953Z"
                      fill="white"
                    />
                  </svg>
                </Button>
              </Box>
              <Box sx={{ mt: "32px" }}>
                <Typography
                  sx={{
                    color: "rgba(0, 0, 0, 1)",
                    fotnSize: "14px",
                    lineHeight: "21px",
                  }}
                >
                  Course:
                </Typography>
                <Typography
                  sx={{
                    color: "rgba(131, 131, 131, 1)",
                    fontSize: "18px",
                    lineHeight: "24px",
                    mt: "10px",
                  }}
                >
                  Bachelor in compurter application
                </Typography>
              </Box>
              <Box sx={{ mt: "32px" }}>
                <Typography
                  sx={{
                    color: "rgba(0, 0, 0, 1)",
                    fotnSize: "14px",
                    lineHeight: "21px",
                  }}
                >
                  Query:
                </Typography>
                <Typography
                  sx={{
                    color: "rgba(131, 131, 131, 1)",
                    fontSize: "18px",
                    lineHeight: "24px",
                    mt: "10px",
                  }}
                >
                  Torem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
                  vulputate libero et velit interdum, ac aliquet odio mattis.
                </Typography>
              </Box>
              <Box sx={{ mt: "32px" }}>
                <Typography
                  sx={{
                    color: "rgba(0, 0, 0, 1)",
                    fotnSize: "14px",
                    lineHeight: "21px",
                  }}
                >
                  Doubts:
                </Typography>
                <Typography
                  sx={{
                    color: "rgba(131, 131, 131, 1)",
                    fontSize: "18px",
                    lineHeight: "24px",
                    mt: "10px",
                  }}
                >
                  Torem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
                  vulputate libero et velit interdum, ac aliquet odio mattis.
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            border: "1px solid rgba(189, 190, 220, 1)",
            mb:"20px",
            borderRadius: "16px",
            padding: "16px 24px",
            display:"flex",
            alignItems: "center",
            "& input": {
              border: "none",
              outline: "none",
              width: "calc(100% - 70px)",
            },
          }}
        >
          <input placeholder="Type Here" />
          <Button
            sx={{
              width: "24px",
              minWidth: "0px",
              height: "24px",
              padding: "0",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18.8392 7.57368L9.04444 17.2489C7.4215 18.8521 4.78996 18.8521 3.16703 17.2489C1.54409 15.6456 1.54409 13.0466 3.16703 11.4433L11.9828 2.73575C13.065 1.66712 14.8187 1.66712 15.9009 2.73575C16.9831 3.80434 16.9831 5.53751 15.9009 6.6061L7.08507 15.3137C6.54432 15.8484 5.66714 15.8484 5.1257 15.3137C4.58496 14.7798 4.58496 13.9132 5.1257 13.3786L12.9618 5.6385L11.9821 4.67093L4.14673 12.4116C3.06454 13.4803 3.06454 15.2134 4.14673 16.282C5.22891 17.3506 6.98258 17.3506 8.06477 16.282L16.8806 7.57437C18.5035 5.97113 18.5035 3.3721 16.8806 1.76883C15.2576 0.165597 12.6261 0.165597 11.0032 1.76883L1.69751 10.9602L1.73123 10.9939C0.0408542 13.1407 0.189457 16.2442 2.18736 18.2171C4.18526 20.1901 7.32587 20.3379 9.49987 18.6673L9.53359 18.7009L19.8182 8.54194L18.8392 7.57368Z"
                fill="#BDBEDC"
              />
            </svg>
          </Button>
          <Button
            sx={{
              background: "rgba(20, 30, 60, 1) !important",
              minWidth: "0px",
              width: "32px",
              height: "32px",
              borderRadius: "50%",
              ml: "10px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <svg
              width="23"
              height="22"
              viewBox="0 0 23 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M21.8563 11.2801H10.2219"
                stroke="white"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M21.858 11.2799L7.57939 18.1547L10.2236 11.2799L7.57939 4.40498L21.858 11.2799Z"
                stroke="white"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </Button>
        </Box>
      </Box>
    </MainContainer>
  );
}

export default ScheduleDetailPage;
